export default __webpack_public_path__ + "static/media/btn_google.ea5aee66.svg";